import { render } from "./OrderBevestigingDetailPage.vue?vue&type=template&id=40a10e58&scoped=true"
import script from "./OrderBevestigingDetailPage.vue?vue&type=script&lang=js"
export * from "./OrderBevestigingDetailPage.vue?vue&type=script&lang=js"

import "./OrderBevestigingDetailPage.vue?vue&type=style&index=0&id=40a10e58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a10e58"]])

export default __exports__